import styled, { css } from 'styled-components/macro'
import Text from 'components/shared/Text'
import activeNav from 'assets/images/decors/activeNav.svg'
import borderDecor from 'assets/images/decors/borderDecor.svg'
import { Color } from 'styles/types'
import { respondAbove } from 'styles/mediaQueries'
import Box from 'components/shared/Box'
import { scrollbar } from 'styles/mixins'

interface NumberProps {
    isActive: boolean
    isCompleted: boolean
}

export const HeaderLogo = styled.img`
    width: 160px;

    @media ${respondAbove.xl} {
        width: 225px;
    }
`

export const HeaderBirthdayCap = styled.img`
    position: absolute;
    width: 22px;
    top: -45%;
    right: -8%;

    @media ${respondAbove.xl} {
        width: 33px;
        right: -9%;
        top: -55%;
    }
`

export const Wrapper = styled.header`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    padding: 18px 0;
    height: 60px;
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 99999;
    box-shadow: 0 8px 24px rgb(32 24 59 / 12%);

    @media ${respondAbove.xl} {
        padding: 28px 0;
        height: auto;
        position: initial;
        box-shadow: none;
    }
`

export const Number = styled.span<NumberProps>`
    ${({ theme, isActive, isCompleted }) => {
        let background: Color = 'grayscale_700'

        if (isCompleted) {
            background = 'secondary_500'
        }

        if (isActive) {
            background = 'primary_500'
        }

        return css`
            background-color: ${theme.colors[background]};
        `
    }}

    ${({ isActive }) =>
        isActive &&
        css`
            &::before {
                content: '';
                background-image: url(${activeNav});
                width: 60px;
                height: 16px;
                background-position: center;
                background-size: contain;
                position: absolute;
                bottom: -28px;
            }
        `};

    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    flex-shrink: 0;
    transition: background-color 100ms ease-in;
    position: relative;

    & > ${Text} {
        display: flex;
    }

    & + ${Text} {
        align-items: center;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }
`

export const SummaryPriceButton = styled(Box)`
    user-select: none;
    cursor: pointer;
`

export const SummaryPriceWrapper = styled(Box)`
    position: relative;

    &::before,
    &::after {
        content: '';
        background-image: url(${borderDecor});
        width: 7px;
        height: 7px;
        display: block;
        position: absolute;
        bottom: -11px;
    }

    &::before {
        left: -14px;
    }

    &::after {
        right: -14px;
        transform: rotate(90deg);
    }
`

export const SummaryWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.grayscale_900_transparent};

    ${SummaryPriceButton} {
        position: relative;

        & > * {
            z-index: 1;
        }

        &::before {
            background-color: ${({ theme }) => theme.colors.grayscale_0};
            content: '';
            width: calc(100% + 16px);
            left: -8px;
            height: calc(100% + 28px);
            top: -10px;
            border-radius: 6px 6px 0 0;
            position: absolute;
        }
    }
`

export const SummaryContent = styled.div`
    ${scrollbar}

    width: 100vw;
    max-height: calc(100% - 52px);
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    display: flex;
    flex-direction: column;
    border-radius: 6px 0 6px 6px;
    padding-top: 32px;
    overflow-y: auto;
    padding-bottom: 16px;
`

export const SummaryButtonWrapper = styled(Box)`
    box-shadow: 0 -8px 24px rgba(206, 211, 231, 0.12);
    width: 100%;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.grayscale_0};
`

export const NavigationItem = styled(Box)<{ isCompleted: boolean }>`
    ${({ isCompleted, onClick }) =>
        isCompleted &&
        onClick &&
        css`
            cursor: pointer;
        `};
`
